// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/AdminRegistration/components/ContentBlock/index.css
// module id = 3145
// module chunks = 0